<div id="footer" *ngIf="footer && showFooter" (click)="closeHeader()" class="footer text-white d-flex flex-column justify-content-between p-5" role="main">
    <div *ngIf="footer.field_menu_footer.length" class="d-flex flex-wrap justify-content-between align-items-center border-b pb-5">
        <div *ngIf="footerPathLogo" class="logo col-12 d-flex justify-content-center justify-content-lg-start col-lg-4 mb-4 mb-lg-0">
            <img loading="lazy" (click)="helpersService.goToHomeLang()" [src]="footerPathLogo" [alt]="footerAltLogo ? footerAltLogo :'footer logo'">
        </div>
        <div *ngIf="nodeService && nodeService.header && nodeService.header.field_link_social" class="col-12 col-lg-4 mb-4 mb-lg-0 d-flex align-items-center justify-content-center text-center">
            <div *ngFor="let social of nodeService.header.field_link_social" class="mb-0 me-3">
                <div *ngFor="let item of social.field_nome_social" class="">
                    <a *ngFor="let linkSocial of social.field_link_social" class="" [href]="linkSocial.value" [attr.aria-label]="'link_social'"
                        target="_blank" aria-label="icon_social_{{item.value.toLowerCase()}}" >
                        <img class="widAndHei-32" loading="lazy" [src]="nodeService.hashMapSocialPngWhite[item.value]" alt="icon_social_{{item.value.toLowerCase()}}">
                    </a>
                </div>
            </div>
        </div>
        <div class=" col-12 col-lg-4 d-flex justify-content-center justify-content-lg-end">
            <div class="me-3 image-custom">
                <a href="https://apps.apple.com/it/app/unilumsa/id1629445219" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'icon apple store'">
                    <img loading="lazy" src="./assets/images/apple.png" alt="icon_apple_store | Lumsa">
                </a>
            </div>
            <div class="image-custom">
                <a href="https://play.google.com/store/apps/details?id=it.cineca.app.lumsa&gl=IT" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'icon play store'">
                    <img loading="lazy" src="./assets/images/play_store-2.png" alt="icon_play_store | Lumsa">
                </a>
            </div>
        </div>
    </div>
    <div class="row pb-4 pt-5">
        <div class="col-12 col-md-6 ">
            <div class="d-flex flex-column col-12 py-3">
                <div class="d-flex flex-column mb-3 col-12 university-name">
                    <p class="ls-p-semibold text-neutral-A1 m-0" style="opacity: .8;">Università LUMSA</p>
                    <p class="ls-p-semibold text-neutral-A1 m-0" style="opacity: .8;">Libera Università Maria Ss. Assunta</p>
                </div>
                <div class="d-flex col-6 w-100 list-container">
                    <div class="row">
                        <div *ngFor="let item of footer.field_menu_footer" class="col-12 col-md-6 py-1">
                            <a *ngIf="!item.external" class="ls-p-semibold text-neutral-A1"
                                [routerLink]="navigationService.splitUrlRouterLink(item.link).path"
                                [queryParams]="navigationService.splitUrlRouterLink(item.link).queryParams"
                                href="JavaScript:void(0);">{{item.label}}</a>
                            <a *ngIf="item.external" class="ls-p-semibold text-neutral-A1" [href]="item.link"
                                target="_blank" [attr.aria-label]="'link_social'" href="JavaScript:void(0);">{{item.label}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <div>
                <div class="d-flex flex-column pt-2">
                    <p class="ls-p-semibold text-neutral-A1 m-0" style="opacity: .8;">{{"FOOTER.SUBSCRIBE_TO_LUMSA" | translate}}
                    - {{"FOOTER.UNIVERSITY_NEWSLETTER" | translate}}</p>
                </div>
                <div class="mb-3 custom-input">
                    <a href="{{'FOOTER.LINK_NEWSLETTER_FORM' | translate}}" target="_blank">
                        <button
                            class="btn btn-outline-light py-2 px-3">
                            {{"FOOTER.SUBSCRIBE" | translate}}
                        </button>
                    </a>
                </div>
                <div class="col-12 mt-5">
                    <div class="d-flex mt-2">
                        <div class="align-self-center partner-content" loading="lazy"
                            *ngFor="let item of footer.field_dettagli_partner" [innerHTML]="item.value">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let item of footer.field_dettagli_universita" class="w-100 border-t text-center p-3 pb-0" [innerHTML]="item.processed"></div>
</div>